import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="text-center py-4">
            <div className="logo-container mb-3">
              <img 
                src="/assets/EABC-LOGO-PNG-1-600x605-1-400x403.png" 
                alt="EABC Logo" 
                className="logo-img"
              />
            </div>
            <h4 className="sidebar-title">B2B-NETWORK ADMIN</h4>
           
          </div>
        </div>
        
        <nav className="sidebar-nav">
          <ul className="nav flex-column">
            {/* <li className="nav-item">
              <Link 
                to='/' 
                className={`nav-link sidebar-link ${isActive('/') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-house-door me-3"></i>
                <span>Dashboard</span>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link 
                to="/admin" 
                className={`nav-link sidebar-link ${isActive('/admin') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-chat-dots me-3"></i>
                <span>Dashboard</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/admin/members" 
                className={`nav-link sidebar-link ${isActive('/admin/members') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-person-circle me-3"></i>
                <span>Members</span>
              </Link>
            </li>
             <li className="nav-item">
              <Link 
                to="/admin/meetings" 
                className={`nav-link sidebar-link ${isActive('/admin/meetings') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-person-circle me-3"></i>
                <span>Meetings</span>
              </Link>
            </li>
             <li className="nav-item">
              <Link 
                to="/admin/logs" 
                className={`nav-link sidebar-link ${isActive('/admin/logs') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-person-circle me-3"></i>
                <span>Logs</span>
              </Link>
            </li>
             <li className="nav-item">
              <Link 
                to="/profile" 
                className={`nav-link sidebar-link ${isActive('/profile') ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <i className="bi bi-person-circle me-3"></i>
                <span>Logout</span>
              </Link>
            </li>
          </ul>
        </nav>
        
        
      </div>
      
      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div className="sidebar-overlay d-md-none" onClick={() => setIsSidebarOpen(false)}></div>
      )}

      <style jsx>{`
        .sidebar {
          position: fixed;
          top: 0;
          left: 0;
          height: 100vh;
          width: 280px;
          background: linear-gradient(135deg, #4361ee 0%, #3f37c9 100%);
          color: white;
          transform: translateX(-100%);
          transition: transform 0.3s ease;
          z-index: 1050;
          display: flex;
          flex-direction: column;
          box-shadow: 4px 0 20px rgba(0,0,0,0.15);
        }
        
        .sidebar.open {
          transform: translateX(0);
        }
        
        @media (min-width: 768px) {
          .sidebar {
            position: relative;
            transform: translateX(0);
          }
          
          .sidebar + .main-content {
            margin-left: 0;
          }
        }
        
        .sidebar-header {
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 1rem;
        }
        
        .logo-container {
          width: 90px;
          height: 90px;
          margin: 0 auto;
          border-radius: 50%;
          background: rgba(255,255,255,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
          box-shadow: 0 8px 16px rgba(0,0,0,0.1);
        }
        
        .logo-img {
          width: 70px;
          height: 70px;
          object-fit: contain;
          border-radius: 50%;
        }
        
        .sidebar-title {
          color: white;
          font-weight: 700;
          font-size: 1.6rem;
          margin-bottom: 0.25rem;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .sidebar-subtitle {
          color: rgba(255,255,255,0.8);
          font-size: 0.875rem;
          margin-bottom: 0;
        }
        
        .sidebar-nav {
          flex-grow: 1;
          padding: 1.5rem 0;
        }
        
        .sidebar-link {
          color: rgba(255,255,255,0.8) !important;
          padding: 1rem 1.5rem;
          border-radius: 0;
          transition: all 0.3s ease;
          border-left: 4px solid transparent;
          display: flex;
          align-items: center;
          text-decoration: none;
          position: relative;
        }
        
        .sidebar-link:hover {
          color: white !important;
          background: rgba(255,255,255,0.1);
          border-left-color: rgba(255,255,255,0.5);
        }
        
        .sidebar-link.active {
          color: white !important;
          background: rgba(255,255,255,0.15);
          border-left-color: #ffd700;
          font-weight: 600;
        }
        
        .sidebar-link.active::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          background: #ffd700;
        }
        
        .sidebar-link i {
          font-size: 1.2rem;
          width: 24px;
        }
        
        .sidebar-footer {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 1rem;
        }
        
        .bg-gradient {
          background: linear-gradient(135deg, #f72585 0%, #b5179e 100%);
          border-radius: 12px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
        }
        
        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0,0,0,0.5);
          z-index: 1040;
        }
        
        @media (max-width: 767px) {
          .sidebar {
            width: 100%;
            max-width: 280px;
          }
        }
      `}</style>
    </>
  );
}

export default Sidebar;